(function() {
	'use strict';
	angular.module('app.setup')
		.controller('addTemplateForm', addTemplateForm);

	addTemplateForm.$inject = ['$scope', '$timeout', '$compile', 'projectTemplatesService', 'editProjectService', 'storeService'];
	
	function addTemplateForm($scope, $timeout, $compile, projectTemplatesService, editProjectService, storeService) {
		var vm = this;
		var adminConfig = storeService.getState().adminConfig;
		vm.leanDirFactoryNdx = adminConfig.factory.id;
		vm.isSaveButtonDisabled = false;
		vm.close = close;
		vm.save = save;
		vm.categoriesTagTransform = categoriesTagTransform;
		vm.projectTypes = [];
		vm.projectAreas = [];
		vm.categories = [];

		function init() {
			// init view model project
			vm.template = {};
			vm.template.crossSite = 'No';
			editProjectService.getProjectTypes(adminConfig.factory.id).then(function (projectTypes) {
				if (projectTypes) {
					vm.projectTypes = projectTypes;
				}
			});
			editProjectService.getAreas(vm.leanDirFactoryNdx, true).then(function (areas) {
				if (!areas || !areas.length) {
					areas = [];
				}
				areas = areas.map(function (obj) {
					return {
						'name': obj.projectArea,
						'ndx': obj.areaNdx
					};
				});
				vm.projectAreas = areas;
			});
			editProjectService.getCategories(vm.leanDirFactoryNdx).then(function (categories) {
				if (categories && categories.length) {
					categories = categories.map(function (category) {
						var transformedCategory = {};
						transformedCategory.name = category.projectCategoryName;
						transformedCategory.id = category.projectCategoryId;
						transformedCategory.status = category.status;
						return transformedCategory;
					});
				} else {
					categories = [];
				}
				vm.categories = categories;
			});
		}
		
		function save() {
			vm.isSaveButtonDisabled = true;
			var data = angular.copy(vm.template);
			if (('' + data.projectArea).indexOf('tag-') === 0) {
				data.newProjectArea = data.projectArea.substring(4);
				data.projectArea = undefined;
			}
			data.isCrossSite = vm.template.crossSite == 'Yes' ? 1 : 0;
			delete data.crossSite;
			var categories = data.categories;
			if (categories && categories.length) {
				data.categoryIds = [];
				data.newCategories = [];
				angular.forEach(categories, function (categoryId) {
					if (('' + categoryId).indexOf('tag-') !== 0) {
						data.categoryIds.push(categoryId);
					} else {
						data.newCategories.push(categoryId.substring(4));
					}
				});
				delete data.categories;
			}
			projectTemplatesService.addTemplate(data, adminConfig.factory.id).then(function(message) {
				$scope.result(message, message == 'Project template created successfully');
				vm.isSaveButtonDisabled = false;
			});
		}
		
		function close() {
			$scope.result('', false);
		}

		function categoriesTagTransform(newTag) {
			return {
				name: newTag,
				id: 'tag-' + newTag
			};
		}

		init();
	}
})();
